import React from 'react';
import CompDashboard from '../Components/CompDashboard';

function PageDashboard() {
    return (
        <div>
            <CompDashboard />
        </div>
    )
}

export default PageDashboard